export default "__VITE_ASSET__$6jcH5NG__"